module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-full",
    class: _vm.classLanceOnline
  }, [_c('div', {
    staticClass: "pregao-leiloeiro-mobile thema1 h-full",
    class: {
      'isLoading': _vm.isLoading
    }
  }, [_c('div', {
    staticClass: "header-pregao"
  }, [_c('div', {
    staticClass: "lote-info"
  }, [_c('span', [_vm._v("Lote " + _vm._s(_vm.lote.numero))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(Number(_vm.lote.quantidadeLeiloes) + 1) + "º LEILÃO")]), _vm._v(" "), (_vm.proximoLote !== null) ? _c('span', [_vm._v("Próximo lote: " + _vm._s(_vm.proximoLote))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "comitente-info"
  }, [_c('div', {
    staticClass: "hora"
  }, [_c('relogio')], 1), _vm._v(" "), _c('div', {
    staticClass: "comitente"
  }, [_c('img', {
    attrs: {
      "src": _vm.lote.comitente.imagemUrl
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "body-pregao"
  }, [_c('div', {
    staticClass: "left-pregao"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('h4', [_vm._v("Lance Atual")]), _vm._v(" "), _c('span', {
    staticClass: "valorAtual show-value",
    class: {
      novoLance: _vm.hasNovoLance
    }
  }, [_vm._v(_vm._s(_vm._f("moeda")(_vm.valor)))])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('h4', [_vm._v("Valor Avaliação")]), _vm._v(" "), _c('span', {
    staticClass: "avaliacao show-value"
  }, [_vm._v(_vm._s(_vm._f("moeda")(_vm.lote.valorAvaliacao)))])])]), _vm._v(" "), _c('div', {
    staticClass: "center-pregao"
  }, [_c('div', {
    staticClass: "item",
    class: {
      online: _vm.apelido !== 'PLATEIA' && _vm.apelido !== '-'
    }
  }, [_c('h4', [_vm._v("Arrematante")]), _vm._v(" "), _c('div', {
    staticClass: "arrematante show-value"
  }, [_c('strong', [_vm._v(_vm._s(_vm.apelido))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lanceLocalidade))])])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    class: _vm.minimoStyle
  }, [_c('h4', [_vm._v("Valor Mínimo")]), _vm._v(" "), _c('span', {
    staticClass: "minimo show-value"
  }, [_vm._v(_vm._s(_vm._f("moeda")(_vm.lote.valorMinimo)))])])]), _vm._v(" "), _c('div', {
    staticClass: "right-pregao"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('h4', {
    style: ('color: ' + _vm.colorStatus)
  }, [_vm._v(_vm._s(_vm.statusLote))]), _vm._v(" "), _c('span', {
    staticClass: "cronometro show-value",
    class: {
      'lance-danger': _vm.countDownTimer <= _vm.calcPercentTimer(30)
    }
  }, [_vm._v("\n            " + _vm._s(_vm.timerPregaoFormatado) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "left-pregao pd-add"
  }, [_c('h3', {
    class: {
      'lote-sucata': _vm.lote.condicao === 7
    }
  }, [_vm._v(_vm._s(_vm.tituloLote))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.descricaoLote))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.observacaoLote))])]), _vm._v(" "), _c('div', {
    staticClass: "image center-pregao",
    class: 'lote-img-status' + _vm.lote.status
  }, [_c('img', {
    ref: "loteImagem",
    attrs: {
      "src": _vm.lote.imagem
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "show-fip"
  }, [_c('div', {
    staticClass: "fip-item"
  }, [_c('h5', [_vm._v("Fipe/Lance")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fipeLance))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "fip-item"
  }, [_c('h5', [_vm._v("Avaliação")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.porcentagemAvaliacao) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "fip-item"
  }, [_c('h5', [_vm._v("Minimo")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.porcentagemMinimo) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "fip-item"
  }, [_c('h5', [_vm._v("Tabela Fipe")]), _vm._v(" "), _c('span', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.lote.valorTabelaFipe)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-pregao"
  }, [_c('div', [_c('span', [_vm._v("Vendidos"), _c('div', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['enter']),
      expression: "['enter']"
    }],
    staticClass: "no-select",
    on: {
      "shortkey": function($event) {
        return _vm.renovarTempo()
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.stats.vendidos))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("Condicionais")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.stats.condicionais))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("Não Vendidos")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.stats.naoVendidos))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("Saldo")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.totalSaldo))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("Saldo Sucata")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.totalSaldoSucata))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("Total")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.totalLotes))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("Total Vendas")]), _vm._v(" "), _c('p', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.stats.totalVendas)))])]), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("Val. Condicionais")]), _vm._v(" "), _c('p', [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.stats.valoresCondicionais)))])]), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("% Venda Comitente")]), _vm._v(" "), _c('p', [_c('small', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("Atual:")]), _vm._v(" " + _vm._s(_vm.percentualVenda))]), _vm._v(" "), (null !== _vm.stats.mediaFipeAnterior) ? _c('p', {
    staticStyle: {
      "font-size": "11px",
      "margin-top": "-5px"
    }
  }, [_vm._v("Anterior: " + _vm._s(_vm.percentualVendaAnterior))]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fip-item"
  }, [_c('h2', [_vm._v("% FIPE")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe714b44","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/pregao-leiloeiro-mobile/Main.vue
// module id = 879
// module chunks = 2